type InfoIconProps = {
  color?: string;
};

const InfoIcon = ({ color = '#FF7400' }: InfoIconProps): JSX.Element => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 505">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M10 0C4.47254 0 0 4.47293 0 10C0 15.5275 4.47293 20 10 20C15.5275 20 20 15.5271 20 10C20 4.47254 15.5271 0 10 0ZM10 18.4375C5.33621 18.4375 1.5625 14.6635 1.5625 10C1.5625 5.33621 5.33652 1.5625 10 1.5625C14.6638 1.5625 18.4375 5.33652 18.4375 10C18.4375 14.6638 14.6635 18.4375 10 18.4375Z"
              fill={color}
            />
          </g>
        </g>
        <g id="Group_3">
          <g id="Group_4">
            <path
              id="Vector_2"
              d="M10 5.0343C9.56852 5.0343 9.21875 5.38407 9.21875 5.81555V10.8465C9.21875 11.278 9.56852 11.6278 10 11.6278C10.4315 11.6278 10.7812 11.278 10.7812 10.8465V5.81555C10.7812 5.38407 10.4315 5.0343 10 5.0343Z"
              fill={color}
            />
          </g>
        </g>
        <g id="Group_5">
          <g id="Group_6">
            <path
              id="Vector_3"
              d="M10 14.6936C10.5825 14.6936 11.0547 14.2214 11.0547 13.6389C11.0547 13.0564 10.5825 12.5842 10 12.5842C9.41751 12.5842 8.94531 13.0564 8.94531 13.6389C8.94531 14.2214 9.41751 14.6936 10 14.6936Z"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default InfoIcon;
